import { gql } from '@apollo/client';

export const getHostsTotal = gql`
  query getHostsTotal($input: ListHostsInput) {
    listHosts(input: $input) {
      total
    }
  }
`;
